import {
    AlternateEmail,
    DriveFileRenameOutline,
    LocationOn,
    PhoneAndroid,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
    Avatar,
    Button,
    Card,
    CircularProgress,
    Grid,
    Typography,
} from "@mui/material";
import { blue, blueGrey, deepOrange } from "@mui/material/colors";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, Outlet, useParams } from "react-router-dom";
import styled from "styled-components";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import LoadingBox from "../../Layouts/LoadingStyle";
import {
    GetInstallerDocs,
    reset,
} from "../../Redux/InstallerSlice/InstallerSlice";

const InstallerShow = () => {
    const dispatch = useDispatch();
    const { installer_id } = useParams();

    const { docs, isSuccess, isLodaing, isError } = useSelector(
        (state) => state.installer
    );
    const installerInfo = docs?.data;
    useEffect(() => {
        const GetUserDocumentsAndInfo = async () => {
            await dispatch(GetInstallerDocs(installer_id));
            await dispatch(reset());
        };
        GetUserDocumentsAndInfo();
    }, [dispatch]);
    return (
        <InstallerInformation>
            {!installerInfo && (
                <Typography align="center" variant="h6" mt={2}>
                    <CircularProgress />
                </Typography>
            )}
            {installerInfo && (
                <>
                    {installerInfo && (
                        <>
                            <Card className="card" sx={{ padding: "10px" }}>
                                <div className="avatar">
                                    <Avatar
                                        className="img"
                                        alt="Remy Sharp"
                                        src={installerInfo?.file?.logo_url}
                                        sx={{
                                            bgcolor: installerInfo?.file
                                                ?.logo_url
                                                ? ""
                                                : blue[500],
                                        }}
                                    >
                                        {/* {installerInfo?.name.slice(0, 2)}{" "} */}
                                    </Avatar>
                                </div>
                                <Typography variant="h6" mt={2}>
                                    <DriveFileRenameOutline
                                        sx={{ fontSize: "1em" }}
                                    ></DriveFileRenameOutline>{" "}
                                    Name :{installerInfo?.name}
                                </Typography>
                                <Typography variant="h6" mt={2}>
                                    <AlternateEmail
                                        sx={{ fontSize: "1em" }}
                                    ></AlternateEmail>{" "}
                                    Email :{installerInfo?.email}
                                </Typography>
                                {installerInfo?.address && (
                                    <Typography variant="h6" mt={2}>
                                        <LocationOn
                                            sx={{ fontSize: "1em" }}
                                        ></LocationOn>{" "}
                                        Address :{installerInfo?.address}
                                    </Typography>
                                )}
                                {installerInfo?.phone && (
                                    <Typography variant="h6" mt={2}>
                                        <PhoneAndroid
                                            sx={{ fontSize: "1em" }}
                                        ></PhoneAndroid>{" "}
                                        Phone :{installerInfo?.business_fax}
                                    </Typography>
                                )}
                            </Card>
                        </>
                    )}
                    <Card className="installer-links">
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Button sx={{ padding: "0" }} fullWidth>
                                    <NavLink to="adders">Adders</NavLink>
                                </Button>
                            </Grid>
                            <Grid item xs={4}>
                                <Button sx={{ padding: "0" }} fullWidth>
                                    <NavLink to="license">License</NavLink>
                                </Button>
                            </Grid>
                            <Grid item xs={4}>
                                <Button sx={{ padding: "0" }} fullWidth>
                                    <NavLink to="docs">Docs</NavLink>
                                </Button>
                            </Grid>
                        </Grid>
                    </Card>
                    {/* {isLodaing && <LoadingAnimation></LoadingAnimation>}
                {!isLodaing && <Outlet />} */}

                    <Outlet />
                </>
            )}
        </InstallerInformation>
    );
};

const InstallerInformation = styled.div`
    background: var(--white);
    color: var(--dark);
    .card {
        .avatar {
            display: flex;
            justify-content: center;
            .img {
                width: 20vh;
                height: 20vh;
            }
        }
        * {
            text-align: center;
        }
    }

    .installer-links a {
        width: 100%;
        padding: 10px;
        border-radius: 10px;
        color: var(--dark);
    }
    .installer-links .active {
        background: var(--light-blue);
        color: var(--white);
    }
    .loading span {
        width: 3em;
        height: 3em;
        color: var(--light-blue);
    }
`;

export default InstallerShow;
